import { SelectedScreens } from '../typings/displayMap';
import { GroupId } from '../typings/groups';

export const OPEN_INDOOR_MAP_EDITOR = 'OPEN_INDOOR_MAP_EDITOR';
export type OPEN_INDOOR_MAP_EDITOR = typeof OPEN_INDOOR_MAP_EDITOR;

export interface OpenIndoorMapEditor {
    type: OPEN_INDOOR_MAP_EDITOR;
    groupId: GroupId;
    checkedByRegion: SelectedScreens;
}

export function openIndoorMapEditor(
    groupId: GroupId,
    checkedByRegion: SelectedScreens
): OpenIndoorMapEditor {
    return {
        type: OPEN_INDOOR_MAP_EDITOR,
        groupId,
        checkedByRegion
    };
}

export const INDOOR_MAP_EDITOR_CHANGE_ITEM = 'INDOOR_MAP_EDITOR_CHANGE_ITEM';
export type INDOOR_MAP_EDITOR_CHANGE_ITEM = typeof INDOOR_MAP_EDITOR_CHANGE_ITEM;

export interface IndoorMapEditorChangeItem {
    type: INDOOR_MAP_EDITOR_CHANGE_ITEM;
    checkedByRegion: SelectedScreens;
}

export function indoorMapEditorChangeItem(
    checkedByRegion: SelectedScreens
): IndoorMapEditorChangeItem {
    return {
        type: INDOOR_MAP_EDITOR_CHANGE_ITEM,
        checkedByRegion
    };
}

export const SAVE_INDOOR_MAP_ACTION = 'SAVE_INDOOR_MAP_ACTION';
export type SAVE_INDOOR_MAP_ACTION = typeof SAVE_INDOOR_MAP_ACTION;

export interface SaveIndoorMapAction {
    type: SAVE_INDOOR_MAP_ACTION;
}

export function saveIndoorMapAction(): SaveIndoorMapAction {
    return {
        type: SAVE_INDOOR_MAP_ACTION
    };
}

export const CLOSE_INDOOR_MAP_EDITOR = 'CLOSE_INDOOR_MAP_EDITOR';
export type CLOSE_INDOOR_MAP_EDITOR = typeof CLOSE_INDOOR_MAP_EDITOR;

export interface CloseIndoorMapEditor {
    type: CLOSE_INDOOR_MAP_EDITOR;
}

export function closeIndoorMapEditor(): CloseIndoorMapEditor {
    return {
        type: CLOSE_INDOOR_MAP_EDITOR
    };
}

export const CLEAR_INDOOR_ERRORS = 'CLEAR_INDOOR_ERRORS';
export type CLEAR_INDOOR_ERRORS = typeof CLEAR_INDOOR_ERRORS;

export interface ClearIndoorErrors {
    type: CLEAR_INDOOR_ERRORS;
    id: string;
}

export function clearIndoorErrors(id: string): ClearIndoorErrors {
    return {
        type: CLEAR_INDOOR_ERRORS,
        id
    };
}

export type OpenIndoorMapEditorAction =
    | OpenIndoorMapEditor
    | IndoorMapEditorChangeItem
    | SaveIndoorMapAction
    | CloseIndoorMapEditor
    | ClearIndoorErrors;
